<template>
  <V2AtomsBaseCard
    size="small"
    class="flex flex-col h-full gap-2 md:gap-4 border-semantic-surface-default hover:border-2 hover:!border-semantic-primary-default shadow-combined-elevation-1"
    :class="wrapperClass"
    :data-testid="dataTestid"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div class="flex-col flex items-center h-full" :class="innerWrapperClass">
      <div v-if="$slots.header || imagePath || badgeTitle">
        <slot name="header">
          <img
            v-if="imagePath"
            :src="imagePath"
            class="rounded-2xl w-full h-full"
            :class="imageClass"
            alt="Card"
          />
        </slot>
      </div>
      <div
        v-if="$slots.body || badgeTitle || title || description || authorName"
        class="flex flex-col text-left gap-1 md:gap-2 md:mt-2 mt-1"
        :class="innerWrapperBodyClass"
      >
        <slot name="body">
          <div v-if="badgeTitle">
            <V2AtomsLabel :theme="badgeTheme">
              {{ badgeTitle }}
            </V2AtomsLabel>
          </div>
          <div
            v-if="title"
            class="font-semibold text-lg/[120%] md:text-2xl/[120%] text-semantic-surface-on-surface line-clamp-3 text-ellipsis"
            :class="{ 'md:mt-2 mt-1': !badgeTitle }"
            v-html="title"
          />
          <NuxtLink
            v-if="showAuthor && authorName"
            :to="authorLink"
            class="font-semibold text-2xs/[120%] md:text-xs/[120%] text-semantic-surface-on-surface"
          >
            by <span class="text-underline font-bold">{{ authorName }}</span>
          </NuxtLink>
          <div
            v-if="description"
            class="md:text-lg/[150%] text-base/[150%] text-semantic-surface-on-surface text-ellipsis line-clamp-3 min-h-[4.625rem]"
            v-html="description"
          />
        </slot>
      </div>
    </div>
    <div v-if="$slots.footer || ctaBtnLabel">
      <slot name="footer">
        <div class="flex justify-end items-end grow">
          <V2AtomsButton
            has-icon-right
            theme="tertiary"
            :to="ctaBtnTo"
            size="small"
            :target="ctaBtnTarget"
          >
            {{ ctaBtnLabel }}
          </V2AtomsButton>
        </div>
      </slot>
    </div>
  </V2AtomsBaseCard>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesCardArticleCard'
})

defineProps({
  dataTestid: {
    type: String,
    default: 'article-card'
  },

  title: {
    type: String,
    default: ''
  },

  authorName: {
    type: String,
    default: ''
  },

  showAuthor: {
    type: Boolean,
    default: true
  },

  authorLink: {
    type: String,
    default: ''
  },

  description: {
    type: String,
    default: ''
  },

  wrapperClass: {
    type: String,
    default: '!max-w-[22rem]'
  },

  innerWrapperClass: {
    type: String,
    default: ''
  },

  imageClass: {
    type: String,
    default: ''
  },

  ctaBtnLabel: {
    type: String,
    default: ''
  },

  ctaBtnTo: {
    type: String,
    default: ''
  },

  ctaBtnTarget: {
    type: String,
    default: ''
  },

  badgeTitle: {
    type: String,
    default: ''
  },

  imagePath: {
    type: String,
    default: ''
  },

  badgeTheme: {
    type: String,
    default: 'default',
    validator: value => ['default', 'outline', 'inverted'].includes(value)
  },

  innerWrapperBodyClass: {
    type: String,
    default: ''
  }
})
</script>
